import { ITimeModel } from 'gen/ApiClient';
import { useContext } from 'react';
import { RecordContext } from '../records/RecordContext';
import { renderTimeModel } from './renderTimeModel';

export function useRenderTimeModel(): (model: ITimeModel) => string {
	const { timeUnitRecord } = useContext(RecordContext);
	return model => renderTimeModel(model, timeUnitRecord);
}
